module.exports = __webpack_public_path__ + "static/media/ci.905ec330.png";